const ignoreRoutes = require('./ignoreRoutes')
const { getLocaleByDomain, getLanguageCodeByLocale } = require('../utils/localization')

module.exports = {
  name: 'domain',

  lookup(req) {
    let language = 'en'

    if (typeof window !== 'undefined') {
      const locale = getLocaleByDomain(window.location.hostname)
      language = getLanguageCodeByLocale(locale)
    } else {
      // For some reason this custom detector is still being called
      // for routes that have been ignored in the NextI18Next
      // configuration. So we’re importing the `ignoreRoutes` array
      // again here and skip any requests to routes defined in there.
      // eslint-disable-next-line security/detect-non-literal-regexp
      if (!new RegExp(ignoreRoutes.join('|')).test(req.originalUrl)) {
        const locale = getLocaleByDomain(req.get('host'))
        language = getLanguageCodeByLocale(locale)
      }
    }

    return language
  },

  cacheUserLanguage(req, res, language, options = {}) {
    //todo
  },
}
